export default __webpack_public_path__ + "d54bf60e397bbac9bc676761eb05706c.png";